define((require) => {
    "use strict";

    const IntegrationModel = require("editor/ui/settings/integrations/IntegrationModel");

    /**
     * Marker class for Matomo Reporting Dashboard Link Visible.
     *
     * @class MatomoReportingDashboardLinkVisibleIntegration
     */
    return IntegrationModel.extend("MatomoReportingDashboardLinkVisibleIntegration", {}, {
        type: "MatomoReportingDashboardLinkVisibleIntegration"
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/MatomoReportingDashboardLinkVisibleIntegrationModel.js